import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsArticleComponent extends Component {
  // Services
  @service data;

  // Getter and setter
  get articleTypes() {
    return this.resolvedArticleTypes.value ?? [];
  }

  // Functions
  resolvedArticleTypes = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'A_TYPE' });
  });

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openNewRecord=false openRecord=false}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='headline' />
            <fieldset.field @property='subHeadline' />

            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field @property='aDate' @type='date-time' />

            <fieldset.field
              @property='categoryId'
              @type='select-record'
              @options={{this.articleTypes}}
            />

            <fieldset.field @property='showMore' @type='checkbox' />
            <fieldset.field @property='showDate' @type='checkbox' />
          </form.fieldset>

          <form.fieldset @titleKey='keywords' as |fieldset|>
            <fieldset.field @property='keywords' />
          </form.fieldset>

          <form.sections.seo />

          <form.fieldset @titleKey='controls' as |fieldset|>
            <fieldset.field @property='cmsLivedate' @type='date-time' />
            <fieldset.field @property='cmsKilldate' @type='date-time' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='teaser' as |fieldset|>
            <fieldset.field @property='teaserHeadline' />
            <fieldset.field @property='teaserSubHeadline' />

            <fieldset.field @property='teaserText' @type='text-editor' />

            <fieldset.field
              @filters={{hash assetFolderId='10'}}
              @property='assetId'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @property='linkId'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='artists' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @property='assets'
              @options={{hash allowedFolder='100'}}
              @type='has-many'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field @property='mediaEmbed' @type='belongs-to' />

            <fieldset.field
              @property='products'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @filters={{hash assetFolderId='17'}}
              @property='documents'
              @on={{hash openNewRecord=false}}
              @type='has-many'
            />

            <fieldset.field @property='links' @type='has-many' />

            <fieldset.field
              @property='recommendedArticles'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>
          <form.fieldset @titleKey='channel' as |fieldset|>
            <fieldset.field
              @property='ownedByChannel'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='taxonomies' as |fieldset|>
            <fieldset.field @property='taxa' @type='has-many' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
